export default "__VITE_ASSET__DcS1pp9H__"